import api from '../services/api';

/**
 * The Help Centre's listening loop, client side. Fire-and-forget: a failed
 * signal must never surface anything to a user who is already lost, so
 * every call swallows its own errors.
 *
 * De-dup: the same signal (kind + payload) is sent at most once per session
 * — a user backspacing through a fruitless query shouldn't log ten rows.
 */
const sent = new Set();

const send = (kind, payload) => {
  const key = `${kind}|${JSON.stringify(payload)}`;
  if (sent.has(key)) return;
  sent.add(key);
  api.post('/help-signals', { kind, payload }).catch(() => {});
};

export const signalSearchNoResults = (query, screen) => {
  const q = (query || '').trim().toLowerCase();
  if (q.length < 3) return; // mid-typing noise, not a real miss
  send('search_no_results', { query: q, screen: screen || '' });
};

export const signalArticleEscalation = (articleId, screen) => {
  if (!articleId) return;
  send('article_escalation', { articleId, screen: screen || '' });
};
